// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".editGlobalOverviewModal___zY8eh{min-width:464px}\n", "",{"version":3,"sources":["webpack://./src/components/GlobalRulesOverview/GlobalRulesOverviewModal/GlobalRulesOverviewModal.css"],"names":[],"mappings":"AAAA,iCACI,eAAA","sourcesContent":[".editGlobalOverviewModal {\n    min-width: 464px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editGlobalOverviewModal": "editGlobalOverviewModal___zY8eh"
};
export default ___CSS_LOADER_EXPORT___;
